window.MIMI_CONFIG = {

  embroideryExtra: 5,
  embroideryExtraVariantId: 15591905231188,
  fonts: {
    flocage: [
      {
        name: "Photoshoot",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Flocage.png?v=1783459186"
      },
      {
        name: "Gabriola",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Flocage_2.png?v=1783459279"
      },
        {
        name: "Gadugi",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Flocage_3.png?v=1783459483"
      },
        {
        name: "Freestyle script",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Flocage_4.png?v=1783460450"
      },
        {
        name: "Lucida caligraphy",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Flocage_5.png?v=1783460451"
      },
        {
        name: "Ananda",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Flocage_6.png?v=1783460450"
      },
        {
        name: "Alyssa stencil script",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/2.png?v=1785612709"
      }
    ],

    broderie: [
      {
        name: "Brussels lights",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/broderie.png?v=1783770093"
      },
      {
        name: "Bergen",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/broderie_2.png?v=1783770101"
      },
      {
        name: "Pusher",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/ecriture_tenu_noel.png?v=1791114912"
      },
      {
        name: "Kingston regular",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/broderie_3.png?v=1783770101"
      }
    ]
  },

  symbols: {
    flocage: [
      {
        name: "Arc en ciel",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Arc-en-ciel.png?v=1783461147"
      },
      {
        name: "Lapin",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Lapin.png?v=1783461146"
      },
      {
        name: "Renard",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Renard.png?v=1783461146"
      },
      {
        name: "Soleil",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/soleil.png?v=1783461146"
      },
      {
        name: "Oiseau",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Oiseau-_vole.png?v=1783461146"
      },
      {
        name: "Nounours",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/nounours_coeur.webp?v=1783461146"
      },
      {
        name: "Papillon",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Papillon.webp?v=1783461146"
      },
      {
        name: "Coeur plein",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/image-swatches-1_4_1739106663020-1739106673.webp?v=1783461146"
      },
      {
        name: "Fleur coeur",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/fleurs_coeur.webp?v=1783461146"
      },
      {
        name: "Coeur fin",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/coeur-fin.png?v=1783461146"
      },
      {
        name: "Feuille",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Feuille.webp?v=1783461146"
      },
      {
        name: "Fleur",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/fleurs.webp?v=1783461146"
      },
      {
        name: "Bonnet de Noël",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/bonnet_noel.jpg?v=1791118212"
      },
      {
        name: "Chaussette de Noël",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/chausette.jpg?v=1791118215"
      },
      {
        name: "Pain d'épice",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/pain_depice.jpg?v=1791118215"
      },
      {
        name: "Cerf",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/cerf.jpg?v=1791118212"
      },
      {
        name: "Lutin",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/lutin.jpg?v=1791118211"
      },
      {
        name: "Tête de rennes",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/tete_de_rennes.jpg?v=1791118211"
      },
      {
        name: "Aucun symbole",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/aucun-symbole.png?v=1784034882"
      }
    ],

    broderie: [
      {
        name: "Arc en ciel",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/arc-en-ciel.jpg?v=1783776808"
      },
      {
        name: "Ourson",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/ourson.jpg?v=1783776751"
      },
      {
        name: "Oie",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/oie.jpg?v=1783776791"
      },
      {
        name: "Coeur",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/coeur.jpg?v=1783776889"
      },
      {
        name: "Marguerite",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/marguerite.jpg?v=1783776889"
      },
            {
        name: "Cerise",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/cerise.jpg?v=1785271365"
      },
      {
        name: "Dinosaure",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Dinosaure.png?v=1793392532"
      },
      {
        name: "Dinosaure 1",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Dinosaure_1.png?v=1793392851"
      },
      {
        name: "Aucun symbole",
        image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/aucun-symbole.png?v=1784034882"
      }
    ]
  },

  colors: {
    flocage: [
{
  name: "Noir",
  value: "#080808ff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Noir.webp?v=1784029961"
},
{
  name: "Gris",
  value: "#afb1afff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Gris.jpg?v=1784033982"
},
{
  name: "Blanc",
  value: "#ffffffff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Blanc.png?v=1784029961"
},
{
  name: "Doré",
  value: "#ca9912b4",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Dore.webp?v=1785443005"
},
{
  name: "Jaune",
  value: "#ffee00ff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Jaune.webp?v=1784029961"
},
{
  name: "Orange",
  value: "#ff8800ff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Orange.webp?v=1784029961"
},
{
  name: "Rouge",
  value: "#ff0000ff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Rouge.webp?v=1784029961"
},
{
  name: "Rose",
  value: "#ff00bfff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Rose.webp?v=1784029961"
},
{
  name: "Fushia",
  value: "#ff009dff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/fushia.webp?v=1785443153"
},
{
  name: "Bleu ciel",
  value: "#4dd7e9ff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/bleu_ciel.jpg?v=1785443154"
},
{
  name: "Bleu clair",
  value: "#3413c7ff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Bleu_clair.jpg?v=1784033690"
},
{
  name: "Bleu marine",
  value: "#3413c7ff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Bleu_marine.jpg?v=1784033619"
},
{
  name: "Vert clair",
  value: "#27ca2fff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Vert_clair.jpg?v=1784033819"
},
{
  name: "Vert foncé",
  value: "#128f27ff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Vert_fonce.jpg?v=1784033859"
},
{
  name: "Marron",
  value: "#9e8943ff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/marron.webp?v=1785443153"
},
{
  name: "Doré pailleté",
  value: "#ca9912b4",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Dore_paillete.webp?v=1784029961"
},
{
  name: "Gris pailleté",
  value: "#afaaaaff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Gris_paillete.webp?v=1784033429"
},
{
  name: "Rouge pailleté",
  value: "#ff0000ff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/Rouge_paillete.webp?v=1784029961"
},
{
  name: "Bleu marine pailleté",
  value: "#1100ffff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/bleu_marine_paillete.jpg?v=1784033146"
},
    ],

    broderie: [
{
  name: "Dark brown-058",
  value: "#ffffff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/IMG_9144.heic?v=1783982120"
},
{
  name: "Marron-323",
  value: "#ffffff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/IMG_9145.heic?v=1783982491"
},
{
  name: "Doré-228",
  value: "#ffffff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/IMG_9146.heic?v=1783982595"
},
{
  name: "Argenté-005",
  value: "#ffffff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/IMG_9159.heic?v=1783982949"
},
{
  name: "Blanc-001",
  value: "#ffffff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/IMG_9147.heic?v=1783982759"
},
{
  name: "Lin-307",
  value: "#ffffff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/IMG_9148.heic?v=1783982949"
},
{
  name: "Beige-843",
  value: "#ffffff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/IMG_9149.heic?v=1783982949"
},
{
  name: "Rose pale-124",
  value: "#ffffff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/IMG_9160.heic?v=1783982949"
},
{
  name: "Rose saumon-079",
  value: "#ffffff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/IMG_9161.heic?v=1783982949"
},
{
  name: "Rose-085",
  value: "#ffffff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/IMG_9166.heic?v=1783982949"
},
{
  name: "Rose foncé-086",
  value: "#ffffff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/IMG_9155.heic?v=1783982949"
},
{
  name: "Magenta-620",
  value: "#ffffff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/IMG_9158.heic?v=1783982949"
},
{
  name: "Bleu clair-017",
  value: "#ffffff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/IMG_9164.heic?v=1783982949"
},
{
  name: "Bleu-405",
  value: "#ffffff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/IMG_9165.heic?v=1783982949"
},
{
  name: "Prussian Blue-007",
  value: "#ffffff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/IMG_9162.heic?v=1783982949"
},
{
  name: "Fresh green-027",
  value: "#ffffff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/IMG_9167.heic?v=1783982949"
},
{
  name: "Vert émeraude-507",
  value: "#ffffff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/IMG_9168.heic?v=1783982949"
},
{
  name: "Jaune-205",
  value: "#ffffff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/IMG_9163.heic?v=1783982949"
},
{
  name: "Orange-208",
  value: "#ffffff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/IMG_9170.heic?v=1783982949"
},
{
  name: "Rouge-800",
  value: "#ffffff",
  image: "https://cdn.shopify.com/s/files/1/1043/4134/0500/files/IMG_9154.heic?v=1783982949"
}
    ]
  }
};